export class Profile {
  constructor(public profileID: number, public profileName: string) {}
}
